import { useState } from 'react';
import './style.scss';
import { FormError } from 'views/mutual/formErrorScroll';

export enum MaskType {
  Start = 1,
  End,
}

export type MaskAttr = {
  type: MaskType;
  displayedCount: number;
};

type EstablishTextProps = {
  inputType: string;
  inputValue?: string;
  setInputValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyEnter?: () => void;
  placeholder?: string;
  disabled?: boolean;
  masked?: MaskAttr;
};

const mask = (target: String | undefined, attr: MaskAttr) => {
  if (!target) return '';

  switch (attr.type) {
    case MaskType.Start: {
      const visible = target.slice(-1 * attr.displayedCount);
      return visible.padStart(target.length, '*');
    }
    case MaskType.End: {
      const visible = target.slice(0, attr.displayedCount);
      return visible.padEnd(target.length, '*');
    }
  }
};

export type InputTemplateDataProps = {
  value?: string;
  error?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
  masked?: MaskAttr;
};

export enum AlignmentType {
  left = 'left',
  right = 'right',
}

export type InputTemplateProps = {
  type?: string;
  placeholder?: string;
  alignment?: AlignmentType;
} & InputTemplateDataProps;

export const InputTemplate = (props: InputTemplateProps) => {
  const {
    type,
    value,
    placeholder,
    disabled,
    error,
    onChange,
    maxLength,
    masked,
    alignment = AlignmentType.left,
  } = props;
  const [hide, setHide] = useState<boolean>(true);

  return (
    <>
      <div className="inputTemplate">
        <input
          className={`inputTemplate_input ${alignment}`}
          type={type}
          value={masked && hide ? mask(value, masked) : value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.value)}
          onFocus={() => setHide(false)}
          maxLength={maxLength}
        />
        <FormError className="inputTemplate_error" error={error} />
      </div>
    </>
  );
};
